import { HStack, Text } from '@chakra-ui/react';
import { CheckCircle, Info } from 'lucide-react';
import { FormattedMessage } from 'react-intl';
import { CalculatePriceResponse, PromoCodeStatus as PromoCodeStatusEnum } from 'api/responseTypes';

type PromoCodeStatusProps = {
  priceCalculation: CalculatePriceResponse | null;
};

export const PromoCodeStatus = ({ priceCalculation }: PromoCodeStatusProps) => {
  if (
    !priceCalculation?.promoCodeStatus ||
    priceCalculation.promoCodeStatus === PromoCodeStatusEnum.NOT_VALID
  ) {
    return null;
  }

  if (!priceCalculation.appliedPromoCodesAmount || priceCalculation.appliedPromoCodesAmount <= 0) {
    return null;
  }

  const getStatusConfig = () => {
    const status = priceCalculation.promoCodeStatus;
    switch (status) {
      case PromoCodeStatusEnum.FULLY_VALID:
        return {
          icon: CheckCircle,
          iconColor: 'green.G600',
          textColor: 'green.G700',
          messageId: 'checkout.promoCode.status.fullyValid',
          defaultMessage: 'تم تطبيق رمز الخصم بنجاح على جميع التذاكر',
        };
      case PromoCodeStatusEnum.PARTIALLY_VALID:
        return {
          icon: Info,
          iconColor: 'orange.600',
          textColor: 'orange.700',
          messageId: 'checkout.promoCode.status.partiallyValid',
          defaultMessage: 'تم تطبيق رمز الخصم على بعض التذاكر فقط',
        };
      default:
        return null;
    }
  };

  const config = getStatusConfig();
  if (!config) {
    return null;
  }

  const Icon = config.icon;

  return (
    <HStack spacing='6px' alignItems='center' justifyContent='flex-end'>
      <Icon size={14} color={config.iconColor} />
      <Text variant='bodySmallRegular' color={config.textColor} fontSize='12px'>
        <FormattedMessage id={config.messageId} defaultMessage={config.defaultMessage} />
      </Text>
    </HStack>
  );
};
